import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import { IAnswerCorporateInitiatives } from "../../../../../../constants/active_learning";
import Card from "../../../../../../atoms/ActiveLearning/Card";
import TreeCard from "../../../../../../atoms/ActiveLearning/TreeCard";
import CorporateInitiativesTable from "../../../../../ActiveLearning/CorporateInitiativesTable";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconLive } from "../../../../../../assets/images/ActiveLearning/icon_live.svg";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue1Material = (props: Issue1MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions[0];
  }, [props.issue?.questions]);

  const initialAnswer: IAnswerCorporateInitiatives = {
    id: "",
    issue_no: NaN,
    question_no: NaN,
    question_id: NaN,
    interest: "",
    reason: "",
    activity: "",
  };
  const initialAnswers = Array.from({ length: 3 }, (_, index) => ({
    ...initialAnswer,
    id: index.toString(),
  }));

  return (
    <>
      {question1 && (
        <div>
          <div className={styles.issue}>
            <div className={styles.header}>
              <span className={styles.no}>
                WORK
                {props.issue?.no && props.issue?.no < 10
                  ? `0${props.issue?.no}`
                  : props.issue?.no}
              </span>
              <p className={styles.title}>{props.issue?.title}</p>
              <p className={styles.read}>
                事例の企業以外にも、課題解決に取り組んでいる企業はたくさんある。
                <br />
                選んだテーマに関する取り組みを行っている企業がないか探してみよう。
                <br />
                ［企業名］［取り組み/届けている価値］［取り上げた理由］を調べて、1つ以上入力しよう。
              </p>
              <p className={styles.example}>
                例：［株式会社〇〇］［株式会社〇〇は環境に優しい製品を作るために、リサイクル素材を使っていた。/届けている価値は「環境に優しい生活」だと思う。］［自分たちの利益だけでなく、多くの人に影響する環境のことまで考えられているところがすごいと思ったから。］
              </p>
            </div>
            <TreeCard title={"テーマ"} text={"テーマが選択されていません。"} />
            <CorporateInitiativesTable isTeacher answers={initialAnswers} />
            <Card label={"TRY"} icon={<IconLive />} title={"グループワーク"}>
              ①同じテーマ同士でグループをつくろう。
              <br />
              ②様々な価値を届ける事例を発表し合おう。
            </Card>
          </div>
        </div>
      )}
    </>
  );
};
export default Issue1Material;
